import { StorefrontModule } from '@vue-storefront/core/lib/modules';
import { isServer } from '@vue-storefront/core/helpers'
import { MARKETING_CONSENT, whenConsented } from 'src/modules/gdpr-cookie-setup/helpers'

export const KEY = 'wiserNotify'

const wiserNotify = {
  namespaced: true
}

const PIXEL_URL = 'https://pt.wisernotify.com/pixel.js?ti=7ni7r1jl8mx2ams'
const PIXEL_INSTALLED_FLAG = 't4hto4'
const DOCUMENT_READY_STATE = 'complete'
const WINDOW_LOAD_EVENT = 'load'

/**
 * @return {void}
 */
const appendPixel = (): void => {
  const script = document.createElement('script')

  script.async = true
  script.src = PIXEL_URL

  document.body.appendChild(script)
}

/**
 * @return {void}
 */
const loadPixel = (): void => {
  if (window[PIXEL_INSTALLED_FLAG]) {
    return
  }

  window[PIXEL_INSTALLED_FLAG] = true

  if (document.readyState === DOCUMENT_READY_STATE) {
    appendPixel()

    return
  }

  window.addEventListener(WINDOW_LOAD_EVENT, appendPixel, false)
}

/**
 * @param {Object} context
 * @return {void}
 */
export const WiserNotifyModule: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, wiserNotify)

  if (isServer) {
    return
  }

  whenConsented(MARKETING_CONSENT, loadPixel)
}
